import type { MyAccountSettingsConfig } from '../../myAccountSettings.types.ts';
import { SUSPENDED_NOTIFICATION_NAMESPACE, SUSPENDED_NOTIFICATION_PAYMENTS_NAMESPACE } from '../../suspendedNotificationNamespaces';

const MY_ACCOUNT_SETTINGS: MyAccountSettingsConfig = {
  isFinancialStatementNavShown: false,
  showsProductPreference: true,
  showsAccountReviewReminder: true,
  showsLockedFundsDetailsCta: true,
  isWalletApiLockedFundsEnabled: false,
  isLifetimeNetDepositsWithDecimals: false,
  // GB: `status` is the only signal we get, and a UK account is also suspended for affordability holds,
  // which an upload would not clear —
  // https://lottoland.atlassian.net/wiki/spaces/CO/pages/3807444997/Account+statuses
  // Leave the CTA off until we can tell the two reasons apart — see WEBD-1381.
  suspendedAccountCta: undefined,
  suspendedNotificationNamespaces: {
    default: SUSPENDED_NOTIFICATION_NAMESPACE,
    payments: SUSPENDED_NOTIFICATION_PAYMENTS_NAMESPACE,
  },
  olderTransactionsContactHref: undefined,
};

export { MY_ACCOUNT_SETTINGS };
